import { registerPlugin } from "@capacitor/core";

/**
 * SusPreviewInfo 发布数据格式，与 BumpyMap.SusPreviewInfoData 一致
 */
export type SusPreviewInfoPayload = Partial<BumpyMap.SusPreviewInfoData>;

export interface VBSPublishPlugin {
  /**
   * 发送 SusPreviewInfo 数据到 VBS 发布
   * @param options SusPreviewInfo 数据，支持 data 包装或平铺格式
   */
  sendVBSData(options: SusPreviewInfoPayload | { data: SusPreviewInfoPayload }): Promise<void>;
}

const VBSPublish = registerPlugin<VBSPublishPlugin>("VBSPublish");

class VBSPublishClientClass {
  /**
   * 发送 SusPreviewInfo 数据
   * @param data SusPreviewInfo 数据
   */
  async sendVBSData(data: SusPreviewInfoPayload): Promise<void> {
    await VBSPublish.sendVBSData(data);
  }
}

export const VBSPublishClient = new VBSPublishClientClass();
export default VBSPublishClient;
